<template>
  <div class="countdown-container">
    <div class="countdown-timer font-family-1 f-w-600">
      {{ formattedCountdown }}
    </div>
  </div>
</template>

<script setup>
import { DateTime, Duration } from "luxon";
// State
const countdown = ref({
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
});

let timerInterval = null;

// Computed
const formattedCountdown = computed(() => {
  const { days, hours, minutes, seconds } = countdown.value;

  // Format each value with leading zeros
  const formattedDays = String(days).padStart(2, "0");
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  // Include days in the display if more than 0 days remain
  if (days > 0) {
    return `${formattedDays} : ${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
  } else {
    return `${formattedHours} : ${formattedMinutes} : ${formattedSeconds}`;
  }
});

// Methods

const calculateTimeToFriday = () => {
  // Current time in UK timezone
  const now = DateTime.now().setZone("Europe/London");

  // Target Friday at 20:00 (8 PM)
  let targetFriday = now.set({
    weekday: 5,
    hour: 20,
    minute: 0,
    second: 0,
    millisecond: 0,
  });

  // If we're already past Friday 8 PM, move to next week's Friday
  if (now > targetFriday) {
    targetFriday = targetFriday.plus({ weeks: 1 });
  }

  const diff = targetFriday
    .diff(now, ["days", "hours", "minutes", "seconds"])
    .toObject();

  countdown.value = {
    days: Math.floor(diff.days ?? 0),
    hours: Math.floor(diff.hours ?? 0),
    minutes: Math.floor(diff.minutes ?? 0),
    seconds: Math.floor(diff.seconds ?? 0),
  };
};

const startCountdown = () => {
  // Calculate immediately on start
  calculateTimeToFriday();

  onNuxtReady(() => {
    timerInterval = setInterval(() => {
      calculateTimeToFriday();
    }, 1000);
  });
};

const stopCountdown = () => {
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
};

// Lifecycle hooks
startCountdown();

onBeforeUnmount(() => {
  // stopCountdown();
});
</script>

<style scoped>
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.countdown-timer {
  color: #07f468;
  line-height: normal;
  font-size: 24px;
}
</style>
